import { render, staticRenderFns } from "./LegoControlCardAssignments.vue?vue&type=template&id=8e2397f0&scoped=true"
import script from "./LegoControlCardAssignments.vue?vue&type=script&lang=js"
export * from "./LegoControlCardAssignments.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardAssignments.vue?vue&type=style&index=0&id=8e2397f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2397f0",
  null
  
)

export default component.exports